app.controller('popupVisitCardPDFController', ['$scope', '$mdDialog', '$sce', 'config', 'idVisitCard',
    function ($scope, $mdDialog, $sce, config, idVisitCard) {

        function setData() {
            $scope.idVisitCard = idVisitCard;
            $scope.url = $sce.trustAsResourceUrl(config.API_URL + '/visitCards/' + $scope.idVisitCard + '/pdf.preview');
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.ok = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {
        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
